import * as React from "react";
import FallBack from "./Fallback";

class ErrorBoundary extends React.Component {
	state = {
		hasCaught: false
	};

	componentDidCatch(error, errorInfo) {
		this.setState({
			hasCaught: true,
			error: error,
			errorInfo: errorInfo
		});

		//Log to Raven \ Sentry
		//@ts-ignore
		Raven.captureException(error, { extra: errorInfo });
	}

	render() {
		if (!this.state.hasCaught) {
			return this.props.children;
		} else {
			return <FallBack />;
		}
	}
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/index.tsx